// Copyright (c) 2025 Deere & Company

import actions from '../../actions-list';

export const closeAmountOfUseModal = () =>

    dispatch => {

        document.body.classList.remove('warranty-modal-is-open');

        dispatch({
            type: actions.CLOSE_TCSM_AMOUNT_OF_USE_MODAL
        });

    };

export const openAmountOfUseModal = actionToTake =>

    dispatch => {

        document.body.classList.add('warranty-modal-is-open');

        dispatch({
            actionToTake,
            type: actions.OPEN_TCSM_AMOUNT_OF_USE_MODAL
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/update-amount-of-use-modal.js